/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronLeft } from "@mui/icons-material";
import { Collapse, ListItem, ListItemIcon, ListItemText, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import { Fragment, useEffect, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { openDrawer } from "../../../shared/state/slices/menu.js";

const DrawerListItem = ({ item, viewALl, isOpen, setIsOpen }) => {
  const location = useLocation();
  const [allChildPath, setAllChildPath] = useState([]);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    var temp = [];
    item.subroutes?.map((items) => {
      temp.push(items.path);
    });
    item.accordian?.map((acc) => {
      acc?.childs.map((ch) => {
        temp.push(ch.path);
      });
    });
    if (temp.find((tmp) => tmp === `/${location.pathname.split("/")[1]}`)) {
      setIsOpen(item.title);
    }
    setAllChildPath(temp);
  }, [item]);
  const isMd = useMediaQuery("(min-width:900px)");

  return (
    <>
      <ListItem
        key={item.title}
        sx={{
          ...styles.listItem,
          height: "45.61px !important",
          "&:hover": {
            ".MuiListItemIcon-root": {
              color: (theme) =>
                theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
            },
            ".MuiListItemText-root": {
              color: (theme) =>
                theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
            },
          },
        }}
        onClick={() => setIsOpen(isOpen === item.title ? null : item.title)}
      >
        {" "}
        <Box
          sx={{
            opacity: item.subroutes?.find(
              (item) => item.path === `/${location.pathname.split("/")[1]}`
            )
              ? 1
              : 0,
          }}
          className="sideBarActive transition"
        ></Box>
        <ListItemIcon
          sx={{
            ...styles.listItemIcon,
            color: (theme) =>
              allChildPath?.find(
                (tmp) => tmp === `/${location.pathname.split("/")[1]}`
              )
                ? theme.palette.mode === "light"
                  ? theme.palette.mode === "light"
                    ? "#001ee4"
                    : "#90caf9"
                  : "#90caf9"
                : theme.palette.mode === "light"
                ? "rgba(162, 162, 168, 0.81)"
                : "#fff",
            fontWeight: allChildPath?.find(
              (tmp) => tmp === `/${location.pathname.split("/")[1]}`
            )
              ? 500
              : 400,
          }}
        >
          {item.icon}
        </ListItemIcon>
        <ListItemText
          primary={item.title}
          sx={{
            ...styles.listItemText,
            color: (theme) =>
              allChildPath?.find(
                (tmp) => tmp === `/${location.pathname.split("/")[1]}`
              )
                ? theme.palette.mode === "light"
                  ? "#001ee4"
                  : "#90caf9"
                : theme.palette.mode === "light"
                ? "rgba(0, 0, 0)"
                : "#fff",
            opacity: viewALl ? 1 : 0,
            ".MuiTypography-root": {
              fontSize: { md: "0.9rem !important" },
              fontWeight: 500,
            },
            transition: "all 450ms ease",
            position: "relative",
          }}
        ></ListItemText>
        <ChevronLeft
          sx={{
            color: (theme) =>
              theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
            transform:
              isOpen === item.title && viewALl
                ? "rotate(90deg)"
                : "rotate(0deg)",
            transition: "300ms all ease",
            mr: 2,
            fontSize: "1rem",
          }}
        />
      </ListItem>

      <Collapse in={isOpen === item.title && viewALl}>
        {item.subroutes.map((item, i) => (
          <Link key={i + "c;ewcm"} to={item.path}>
            <ListItem
              onClick={() => {
                if (!isMd) {
                  dispatch(openDrawer(false));
                }
              }}
              key={i}
              sx={{
                ...styles.listItem,
                "&:hover": {
                  ".MuiListItemIcon-root": {
                    color: (theme) =>
                      theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
                  },
                  ".MuiListItemText-root": {
                    color: (theme) =>
                      theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  ...styles.listItemIcon,
                  paddingLeft: "5px !important",
                  color: (theme) =>
                    `/${location.pathname.split("/")[1]}` === item.path
                      ? theme.palette.mode === "light"
                        ? "#001ee4"
                        : "#90caf9"
                      : theme.palette.mode === "light"
                      ? "rgba(162, 162, 168, 0.81)"
                      : "#fff",
                }}
              >
                -
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                sx={{
                  ...styles.listItemText,
                  opacity: viewALl ? 1 : 0,
                  transition: "all 450ms ease",
                  color: (theme) =>
                    `/${location.pathname.split("/")[1]}` === item.path
                      ? theme.palette.mode === "light"
                        ? "#001ee4"
                        : "#90caf9"
                      : theme.palette.mode === "light"
                      ? "rgba(0, 0, 0)"
                      : "#fff",
                  ".MuiTypography-root": {
                    fontSize: { md: "0.8rem !important" },
                  },
                }}
              />
            </ListItem>
          </Link>
        ))}
        {item?.accordian && <DrawerListItem2 item={item} />}
      </Collapse>
    </>
  );
};
const DrawerListItem2 = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    item.accordian.map((accr, index) => {
      if (
        accr.childs?.find(
          (child) => child.path === `/${location.pathname.split("/")[1]}`
        )
      ) {
        setIsOpen({ [index]: isOpen[index] ? false : true });
      }
    });
  }, []);
  const isMd = useMediaQuery("(min-width:900px)");
  const dispatch = useDispatch();

  return (
    <>
      {item?.accordian.map((items, index) => (
        <Fragment key={index + "acc"}>
          <ListItem
            key={items.title}
            sx={{
              ...styles.listItem,
              "&:hover": {
                ".MuiListItemIcon-root": {
                  color: (theme) =>
                    theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
                },
                ".MuiListItemText-root": {
                  color: (theme) =>
                    theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
                },
              },
            }}
            onClick={() => setIsOpen({ [index]: isOpen[index] ? false : true })}
          >
            <ListItemIcon sx={styles.listItemIcon}>{items.icon}</ListItemIcon>
            <ListItemText
              primary={items.title}
              sx={{
                ...styles.listItemText,
                ".MuiTypography-root": {
                  fontSize: { md: "0.8rem !important" },
                },
                color: (theme) =>
                  items.childs?.find(
                    (item) =>
                      item.path === `/${location.pathname.split("/")[1]}`
                  )
                    ? theme.palette.mode === "light"
                      ? "#001ee4"
                      : "#90caf9"
                    : theme.palette.mode === "light"
                    ? "rgba(0, 0, 0)"
                    : "#fff",
              }}
            />

            <ChevronLeft
              sx={{
                color: (theme) =>
                  theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
                transform: isOpen[index] ? "rotate(90deg)" : "rotate(0deg)",
                transition: "300ms all ease",
                mr: 2,
                fontSize: "1rem",
              }}
            />
          </ListItem>
          <Collapse in={isOpen[index]}>
            {items.childs.map((item, i) => (
              <Link key={i + "c;ewcdm"} to={item.path}>
                <ListItem
                  onClick={() => {
                    if (!isMd) {
                      dispatch(openDrawer(false));
                    }
                  }}
                  key={i}
                  sx={{
                    ...styles.listItem,
                    "&:hover": {
                      ".MuiListItemIcon-root": {
                        color: (theme) =>
                          theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9",
                      },
                      ".MuiListItemText-root": {
                        color: (theme) =>
                          theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9",
                      },
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      ...styles.listItemIcon,
                      paddingLeft: "5px !important",
                      color: (theme) =>
                        `/${location.pathname.split("/")[1]}` === item.path
                          ? theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9"
                          : theme.palette.mode === "light"
                          ? "rgba(0, 0, 0)"
                          : "#fff",
                    }}
                  >
                    -
                  </ListItemIcon>
                  <ListItemText
                    primary={item.name}
                    sx={{
                      ...styles.listItemText,
                      color: (theme) =>
                        `/${location.pathname.split("/")[1]}` === item.path
                          ? theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9"
                          : theme.palette.mode === "light"
                          ? "rgba(0, 0, 0)"
                          : "#fff",

                      ".MuiTypography-root": {
                        fontSize: { md: "0.8rem !important" },
                      },
                    }}
                  />
                </ListItem>
              </Link>
            ))}
          </Collapse>
        </Fragment>
      ))}
    </>
  );
};
const styles = {
  innerBox: {
    py: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    height: "70px",
    marginBottom: "40px",
    color: (theme) =>
      theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
  },
  listItem: {
    cursor: "pointer",
    position: "relative",
    width: { md: "12.1875rem" },
    px: "0px",
  },
  listItemIcon: {
    fontSize: "1.25rem",
    color: (theme) =>
      theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
  },
  listItemText: {
    textAlign: "left",
    color: (theme) =>
      theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
  },
  sublistItem: {
    direction: "rtl",
    cursor: "pointer",
    color: (theme) =>
      theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
  },
};

export default DrawerListItem;
